export default __webpack_public_path__ + "static/media/nasdag.b091b163.svg";